import { MapPin } from "lucide-react";
import { OrderBreakdown } from "@/components/OrderBreakdown";
import { pad2, rupiah, STATUS, formatTime } from "@/lib/api";

const ACTIONS = {
  menunggu_pembayaran: [["diproses", "Konfirmasi Pembayaran"], ["dibatalkan", "Batalkan"]],
  menunggu_konfirmasi: [["diproses", "Konfirmasi Pembayaran"], ["dibatalkan", "Batalkan"]],
  diproses: [["diantar", "Tandai Diantar"], ["dibatalkan", "Batalkan"]],
  diantar: [["selesai", "Selesai"]],
};

export const OrderCard = ({ order: o, onUpdate }) => {
  const st = STATUS[o.status];
  const urgent = o.status === "menunggu_konfirmasi";
  return (
    <div className={`card-paper p-5 flex flex-col ${urgent ? "ring-2 ring-orange-300" : ""}`} data-testid={`staff-order-card-${o.id}`}>
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="font-bold text-lg">{o.code}</div>
          <div className="text-xs text-muted2">{formatTime(o.created_at)} · {o.payment_method === "qris" ? "QRIS" : "Transfer Bank"}</div>
        </div>
        <span className={`text-xs font-semibold px-2.5 py-1 rounded-full border whitespace-nowrap ${st.cls}`} data-testid={`staff-order-status-${o.id}`}>{st.label}</span>
      </div>
      <div className="flex items-center gap-2 mt-3 bg-sage-100 rounded-lg px-3 py-2 font-semibold text-forest" data-testid={`staff-order-location-${o.id}`}>
        <MapPin className="w-4 h-4" /> {o.outlet_code || "-"} · {o.order_type === "takeaway" ? "Bawa pulang" : `Lantai ${o.floor} · Meja ${pad2(o.table)}`}{o.source === "kasir" && <span className="ml-auto text-[11px] px-2 py-0.5 rounded-full bg-paper">Kasir</span>}
      </div>
      {o.customer_name && (
        <div className="text-xs text-muted2 mt-2 flex flex-wrap items-center gap-1.5" data-testid={`staff-order-customer-${o.id}`}>
          <span className="font-semibold text-ink">{o.customer_name}</span>
          {o.customer_whatsapp && <a href={`https://wa.me/${o.customer_whatsapp}`} target="_blank" rel="noreferrer" className="text-forest underline" data-testid={`staff-order-wa-${o.id}`}>+{o.customer_whatsapp}</a>}
          <span className={`px-1.5 py-0.5 rounded-full font-semibold ${o.customer_id ? "bg-sage-100 text-forest" : "bg-paper border border-sage-200"}`}>{o.customer_id ? "Member" : "Tamu"}</span>
          {o.customer_email && <span>{o.customer_email}</span>}
        </div>
      )}
      <ul className="mt-3 text-sm space-y-1 flex-1">
        {o.items.map((i) => <li key={i.menu_id}><div className="flex justify-between"><span>{i.qty}× {i.name}</span><span className="text-muted2">{rupiah(i.qty * i.price)}</span></div>{i.note && <div className="text-xs font-semibold text-amber-800 bg-amber-50 rounded px-1.5 py-0.5 mt-0.5 inline-block" data-testid={`order-item-note-${o.id}-${i.menu_id}`}>Catatan: {i.note}</div>}</li>)}
      </ul>
      {o.notes && <p className="text-xs bg-amber-50 border border-amber-200 rounded-md px-2.5 py-1.5 mt-3">Catatan: {o.notes}</p>}
      <div className="mt-3"><OrderBreakdown o={o} testid={`staff-order-breakdown-${o.id}`} /></div>
      <div className="flex justify-between font-bold border-t border-sage-200 mt-3 pt-3"><span>Total dibayar</span><span className="text-lg" data-testid={`staff-order-total-${o.id}`}>{rupiah(o.total).slice(0, o.unique_code ? -3 : undefined)}{o.unique_code > 0 && <span className="text-amber-700 bg-amber-100 rounded px-0.5">{rupiah(o.total).slice(-3)}</span>}</span></div>
      {ACTIONS[o.status] && (
        <div className="flex gap-2 mt-4">
          {ACTIONS[o.status].map(([to, label]) => (
            <button key={to} onClick={() => (to !== "dibatalkan" || window.confirm(`Batalkan pesanan ${o.code}?`)) && onUpdate(o.id, to)} data-testid={`staff-update-status-button-${o.id}-${to}`}
              className={to === "dibatalkan" ? "px-3 py-2.5 rounded-lg border border-red-200 text-red-700 text-sm hover:bg-red-50" : "btn-forest flex-1 py-2.5 text-sm"}>
              {label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
